export default __webpack_public_path__ + "static/media/1780.99d0a3f5.png";